import { render, staticRenderFns } from "./FrontendFilters.vue?vue&type=template&id=561161bf&scoped=true&"
import script from "./FrontendFilters.vue?vue&type=script&lang=ts&"
export * from "./FrontendFilters.vue?vue&type=script&lang=ts&"
import style0 from "./FrontendFilters.vue?vue&type=style&index=0&id=561161bf&prod&lang=scss&scoped=true&"
import style1 from "./FrontendFilters.vue?vue&type=style&index=1&id=561161bf&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "561161bf",
  null
  
)

export default component.exports